// Concretss × Sinners — wow layer: intro + WebGL mesh + cursor blob + 3D tilt + parallax + scroll drift
(function () {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasTouch = matchMedia('(hover: none)').matches;

  /* ============================ Cart drawer ============================ */
  (function initCartDrawer() {
    const drawer = document.getElementById('merch-cart-drawer');
    if (!drawer) return;
    const itemsEl = document.getElementById('cart-drawer-items');
    const emptyEl = document.getElementById('cart-drawer-empty');
    const footEl  = document.getElementById('cart-drawer-foot');
    const subtotalEl = document.getElementById('cart-subtotal');
    const checkoutBtn = document.getElementById('cart-checkout');

    function moneyCOP(cents) {
      const v = Math.round(cents / 100);
      return '$' + v.toLocaleString('es-CO');
    }

    async function loadCart() {
      try {
        const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await r.json();
        renderCart(cart);
      } catch (e) { console.warn('cart load:', e); }
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }

    // Free shipping threshold: camiseta + tank = $280.000 COP = 28000000 cents
    const FREE_SHIP_THRESHOLD = 28000000;
    const progressEl = document.getElementById('cart-progress');
    const progressTextEl = document.getElementById('cart-progress-text');
    const progressFillEl = document.getElementById('cart-progress-fill');

    function getSubtotal(cart) {
      // items_subtotal_price = items only (no shipping/discounts). Fallback to total_price.
      return (typeof cart.items_subtotal_price === 'number') ? cart.items_subtotal_price : cart.total_price;
    }

    function renderProgress(cart) {
      if (!progressEl) return;
      if (!cart.item_count) { progressEl.hidden = true; return; }
      progressEl.hidden = false;
      const total = getSubtotal(cart);
      const remaining = Math.max(0, FREE_SHIP_THRESHOLD - total);
      const pct = Math.min(100, (total / FREE_SHIP_THRESHOLD) * 100);
      progressFillEl.style.width = pct + '%';
      if (remaining > 0) {
        progressTextEl.innerHTML = `Te faltan <strong>${moneyCOP(remaining)}</strong> para envío gratis`;
        progressEl.classList.remove('is-complete');
      } else {
        progressTextEl.innerHTML = `<span class="cart-progress-icon">✓</span> ¡Envío gratis incluido!`;
        progressEl.classList.add('is-complete');
      }
    }

    // Catalog from Liquid for upsell
    let CATALOG = [];
    try {
      const catEl = document.getElementById('merch-catalog');
      if (catEl) CATALOG = JSON.parse(catEl.textContent);
    } catch (e) { CATALOG = []; }

    const upsellEl = document.getElementById('cart-upsell');
    const upsellRail = document.getElementById('cart-upsell-rail');
    const upsellSub = document.getElementById('cart-upsell-sub');
    const shippingEl = document.getElementById('cart-shipping');
    const SHIPPING_FEE = 1000000; // $10.000 in cents

    function renderUpsell(cart) {
      if (!upsellEl || !upsellRail || !CATALOG.length) { if (upsellEl) upsellEl.hidden = true; return; }
      // Filter out products already in cart
      const inCart = new Set(cart.items.map(i => String(i.product_id)));
      const available = CATALOG.filter(p => !inCart.has(String(p.id)) && p.variant);
      if (!available.length) { upsellEl.hidden = true; return; }
      upsellEl.hidden = false;
      const remaining = Math.max(0, FREE_SHIP_THRESHOLD - getSubtotal(cart));
      upsellSub.textContent = remaining > 0 ? `+${moneyCOP(remaining)} para envío gratis` : '';
      upsellRail.innerHTML = available.slice(0, 8).map(p => `
        <a href="${escapeHtml(p.url)}" class="upsell-card" data-add="${p.variant.id}">
          <div class="upsell-card-media">
            <img src="${escapeHtml(p.image)}" alt="${escapeHtml(p.title)}" loading="lazy">
          </div>
          <div class="upsell-card-body">
            <div class="upsell-card-title">${escapeHtml(p.title.replace(' T-SHIRT', '').replace(' TANK TOP', ' TANK'))}</div>
            <div class="upsell-card-price">${moneyCOP(p.price)}</div>
          </div>
          <button type="button" class="upsell-card-add" data-add-id="${p.variant.id}" aria-label="Agregar">+</button>
        </a>
      `).join('');
    }

    if (upsellRail) {
      upsellRail.addEventListener('click', async (e) => {
        const addBtn = e.target.closest('[data-add-id]');
        if (!addBtn) return;
        e.preventDefault();
        e.stopPropagation();
        const variantId = addBtn.dataset.addId;
        addBtn.disabled = true;
        addBtn.textContent = '·';
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          await loadCart();
        } catch (err) {
          addBtn.textContent = '!';
          setTimeout(() => { addBtn.disabled = false; addBtn.textContent = '+'; }, 1500);
        }
      });
    }

    /* Delivery estimate: 3-5 business days from today */
    const SP_DAYS = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
    const SP_MONTHS = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    function addBusinessDays(date, days) {
      const d = new Date(date.getTime());
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    }
    function fmtDeliveryDate(d) {
      const day = SP_DAYS[d.getDay()];
      return `${day} ${d.getDate()} ${SP_MONTHS[d.getMonth()]}`;
    }
    function renderDelivery() {
      const el = document.getElementById('cart-delivery-dates');
      if (!el) return;
      const today = new Date();
      const min = addBusinessDays(today, 3);
      const max = addBusinessDays(today, 5);
      el.textContent = `${fmtDeliveryDate(min)} — ${fmtDeliveryDate(max)}`;
    }

    function renderShipping(cart) {
      if (!shippingEl) return;
      if (getSubtotal(cart) >= FREE_SHIP_THRESHOLD) {
        shippingEl.textContent = 'Gratis';
        shippingEl.classList.add('is-free');
      } else {
        shippingEl.textContent = '$10.000';
        shippingEl.classList.remove('is-free');
      }
    }

    function totalWithShipping(cart) {
      const subtotal = getSubtotal(cart);
      const ship = subtotal >= FREE_SHIP_THRESHOLD ? 0 : SHIPPING_FEE;
      return subtotal + ship;
    }

    function renderCart(cart) {
      // Sync header cart count
      document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
      renderProgress(cart);
      if (!cart.item_count) {
        itemsEl.hidden = true;
        emptyEl.hidden = false;
        footEl.hidden = true;
        if (upsellEl) upsellEl.hidden = true;
        return;
      }
      itemsEl.hidden = false;
      emptyEl.hidden = true;
      footEl.hidden = false;
      renderShipping(cart);
      renderUpsell(cart);
      renderDelivery();
      itemsEl.innerHTML = cart.items.map((item) => `
        <article class="cart-item" data-key="${item.key}">
          <div class="cart-item-media">
            ${item.image ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}
          </div>
          <div class="cart-item-body">
            <div class="cart-item-row">
              <span class="cart-item-title">${escapeHtml(item.product_title)}</span>
              <span class="cart-item-price">${moneyCOP(item.final_line_price)}</span>
            </div>
            ${item.variant_title ? `<div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>` : ''}
            <div class="cart-item-row cart-item-bottom">
              <div class="cart-qty">
                <button type="button" class="qty-btn" data-qty="${item.key}" data-delta="-1" aria-label="Reducir">−</button>
                <span class="qty-val">${item.quantity}</span>
                <button type="button" class="qty-btn" data-qty="${item.key}" data-delta="1" aria-label="Aumentar">+</button>
              </div>
              <button type="button" class="cart-item-remove" data-remove="${item.key}">Eliminar</button>
            </div>
          </div>
        </article>
      `).join('');
      subtotalEl.textContent = moneyCOP(totalWithShipping(cart));
    }

    async function changeQty(key, qty) {
      try {
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        const cart = await r.json();
        renderCart(cart);
      } catch (e) { console.warn('cart change:', e); }
    }

    itemsEl.addEventListener('click', (e) => {
      const qBtn = e.target.closest('[data-qty]');
      const rBtn = e.target.closest('[data-remove]');
      if (qBtn) {
        const key = qBtn.dataset.qty;
        const delta = parseInt(qBtn.dataset.delta, 10);
        const cur = parseInt(qBtn.closest('.cart-item').querySelector('.qty-val').textContent, 10);
        changeQty(key, Math.max(0, cur + delta));
      } else if (rBtn) {
        changeQty(rBtn.dataset.remove, 0);
      }
    });

    /* iOS-safe body scroll lock: freeze scroll position via position:fixed
       + intercept touchmove globally except inside scrollable drawer regions */
    function preventOutsideTouch(e) {
      // Allow vertical scroll inside cart-drawer-body and horizontal scroll inside cart-upsell-rail
      if (e.target.closest('.cart-drawer-body') || e.target.closest('.cart-upsell-rail')) return;
      e.preventDefault();
    }
    function lockBodyScroll() {
      const y = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.lockedY = String(y);
      document.body.style.position = 'fixed';
      document.body.style.top = `-${y}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('touchmove', preventOutsideTouch, { passive: false });
    }
    function unlockBodyScroll() {
      const y = parseInt(document.body.dataset.lockedY || '0', 10);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      delete document.body.dataset.lockedY;
      document.removeEventListener('touchmove', preventOutsideTouch);
      window.scrollTo(0, y);
    }

    function openDrawer() {
      drawer.hidden = false;
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      lockBodyScroll();
      loadCart();
      // Push a history state so iOS back-swipe / Android back closes the drawer
      // instead of navigating away from the PDP.
      if (!(history.state && history.state.merchDrawerOpen)) {
        history.pushState({ merchDrawerOpen: true }, '');
      }
    }
    function closeDrawer(fromPopstate) {
      drawer.classList.remove('is-open');
      setTimeout(() => { drawer.hidden = true; unlockBodyScroll(); }, 320);
      // Consume the history entry we added on open, unless the browser already did
      if (!fromPopstate && history.state && history.state.merchDrawerOpen) {
        history.back();
      }
    }

    // Open: any .merch-cart-pill click in the page
    document.addEventListener('click', (e) => {
      const pill = e.target.closest('.merch-cart-pill');
      const close = e.target.closest('[data-close="cart"]');
      const openBtn = e.target.closest('[data-open="cart"]');
      if (pill || openBtn) { e.preventDefault(); openDrawer(); }
      else if (close)       { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
    window.addEventListener('popstate', () => {
      if (!drawer.hidden) closeDrawer(true);
    });

    // Hook for PDP add-to-cart AJAX (called from merch-pdp.js)
    window.__merchCart = { open: openDrawer, refresh: loadCart };
  })();

  /* ============================ Intro (charging page) ============================ */
  (function initIntro() {
    const intro = document.getElementById('merch-intro');
    if (!intro) return;
    if (reduceMotion) { intro.remove(); return; }
    // Total intro duration: ~2.4s (background + logo + progress bar fill)
    const DURATION = 2300;
    function dismiss() {
      intro.classList.add('is-exit');
      intro.addEventListener('animationend', () => intro.remove(), { once: true });
      setTimeout(() => intro.remove(), 1500);
    }
    if (document.readyState === 'complete') {
      setTimeout(dismiss, DURATION);
    } else {
      window.addEventListener('load', () => setTimeout(dismiss, DURATION));
    }
    // Click to skip
    intro.addEventListener('click', dismiss);
  })();

  /* ============================ WebGL gradient mesh ============================ */
  (function initMesh() {
    const canvas = document.getElementById('merch-mesh');
    if (!canvas) return;
    const gl = canvas.getContext('webgl', { antialias: false, alpha: true, premultipliedAlpha: false });
    if (!gl) return;

    function resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 1.75);
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      gl.viewport(0, 0, canvas.width, canvas.height);
    }
    resize();
    window.addEventListener('resize', resize);

    const vert = `
      attribute vec2 aPos;
      varying vec2 vUv;
      void main() {
        vUv = aPos * 0.5 + 0.5;
        gl_Position = vec4(aPos, 0.0, 1.0);
      }
    `;
    const frag = `
      precision highp float;
      varying vec2 vUv;
      uniform float uTime;
      uniform vec2 uMouse;
      uniform vec2 uRes;

      // Simplex-ish noise (fast)
      vec2 hash(vec2 p){p=vec2(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3)));return -1.0+2.0*fract(sin(p)*43758.5453123);}
      float noise(vec2 p){const float K1=0.366025404;const float K2=0.211324865;vec2 i=floor(p+(p.x+p.y)*K1);vec2 a=p-i+(i.x+i.y)*K2;float m=step(a.y,a.x);vec2 o=vec2(m,1.0-m);vec2 b=a-o+K2;vec2 c=a-1.0+2.0*K2;vec3 h=max(0.5-vec3(dot(a,a),dot(b,b),dot(c,c)),0.0);vec3 n=h*h*h*h*vec3(dot(a,hash(i)),dot(b,hash(i+o)),dot(c,hash(i+1.0)));return dot(n,vec3(70.0));}
      float fbm(vec2 p){float v=0.0;float a=0.5;for(int i=0;i<4;i++){v+=a*noise(p);p*=2.05;a*=0.5;}return v;}

      void main() {
        vec2 uv = vUv;
        float aspect = uRes.x / uRes.y;
        vec2 p = vec2(uv.x * aspect, uv.y);

        float t = uTime * 0.06;
        float warp = fbm(p * 1.4 + vec2(t, t * 0.7));
        vec2 q = p + vec2(warp * 0.3, warp * 0.25);
        float n1 = fbm(q * 1.1 - vec2(t * 0.5, 0.0));
        float n2 = fbm(q * 0.7 + vec2(0.0, t * 0.3));

        // Palette: cemento / acero / shadow
        vec3 cConcrete = vec3(0.43, 0.48, 0.53);   // #6e7a87
        vec3 cSteel    = vec3(0.23, 0.27, 0.32);   // #3a4452
        vec3 cShadow   = vec3(0.10, 0.12, 0.15);   // #1a1f27
        vec3 cHighlight= vec3(0.77, 0.80, 0.84);   // pale

        vec3 col = mix(cShadow, cSteel, smoothstep(-0.3, 0.6, n1));
        col = mix(col, cConcrete, smoothstep(0.0, 0.9, n2));
        col = mix(col, cHighlight, smoothstep(0.6, 1.1, n1 + n2) * 0.4);

        // Mouse highlight bloom
        vec2 m = uMouse / uRes;
        float mDist = distance(uv, vec2(m.x, 1.0 - m.y));
        col += cHighlight * smoothstep(0.45, 0.0, mDist) * 0.12;

        // Subtle vignette
        float v = 1.0 - dot(uv - 0.5, uv - 0.5) * 0.8;
        col *= clamp(v, 0.5, 1.05);

        gl_FragColor = vec4(col, 1.0);
      }
    `;

    function compile(type, src) {
      const s = gl.createShader(type);
      gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
        console.warn('shader:', gl.getShaderInfoLog(s));
        return null;
      }
      return s;
    }
    const vs = compile(gl.VERTEX_SHADER, vert);
    const fs = compile(gl.FRAGMENT_SHADER, frag);
    if (!vs || !fs) return;
    const prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    gl.useProgram(prog);

    const buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
    const aPos = gl.getAttribLocation(prog, 'aPos');
    gl.enableVertexAttribArray(aPos);
    gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

    const uTime = gl.getUniformLocation(prog, 'uTime');
    const uMouse = gl.getUniformLocation(prog, 'uMouse');
    const uRes = gl.getUniformLocation(prog, 'uRes');

    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    if (!hasTouch) {
      window.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; }, { passive: true });
    }
    const start = performance.now();
    function render(now) {
      const t = (now - start) / 1000;
      gl.uniform1f(uTime, t);
      gl.uniform2f(uMouse, mx, my);
      gl.uniform2f(uRes, canvas.width, canvas.height);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      if (!reduceMotion) requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
    setTimeout(() => canvas.classList.add('is-ready'), 60);
  })();

  /* ============================ Cursor blob (desktop only) ============================ */
  (function initCursor() {
    if (hasTouch || reduceMotion) return;
    const blob = document.getElementById('merch-cursor');
    if (!blob) return;
    let mx = -200, my = -200, bx = -200, by = -200;
    document.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; }, { passive: true });
    document.addEventListener('mouseenter', () => blob.classList.add('is-active'));
    let raf;
    function loop() {
      bx += (mx - bx) * 0.18;
      by += (my - by) * 0.18;
      blob.style.translate = `${bx}px ${by}px`;
      raf = requestAnimationFrame(loop);
    }
    requestAnimationFrame(() => { blob.classList.add('is-active'); loop(); });
  })();

  if (reduceMotion) return;

  /* Gradient drifts as user scrolls (Skylrk-style background animation) */
  let lastY = 0;
  let scrollTick = 0;
  function gradientTick() {
    const y = lastY;
    // Drift the radial highlight position based on scroll — non-linear for organic feel
    const shiftY = Math.min(y * 0.18, 280);   // 0–280px vertical
    const shiftX = Math.sin(y / 600) * 24;    // ±24px lateral wobble
    document.body.style.setProperty('--scroll-y', `${shiftY}px`);
    document.body.style.setProperty('--scroll-x', `${shiftX}px`);
    scrollTick = 0;
  }
  window.addEventListener('scroll', () => {
    lastY = window.scrollY;
    if (!scrollTick) scrollTick = requestAnimationFrame(gradientTick);
  }, { passive: true });

  const grid = document.getElementById('merch-grid');
  if (!grid) return;
  const floaters = Array.from(grid.querySelectorAll('.floater'));
  const cursorBlob = document.getElementById('merch-cursor');

  /* 3D tilt on hover — desktop only */
  if (!hasTouch) {
    floaters.forEach((el) => {
      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;
        const py = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--tilt-x', `${(-py * 10).toFixed(2)}deg`);
        el.style.setProperty('--tilt-y', `${(px * 10).toFixed(2)}deg`);
        if (cursorBlob) cursorBlob.classList.add('is-near');
      });
      el.addEventListener('mouseleave', () => {
        el.style.setProperty('--tilt-x', '0deg');
        el.style.setProperty('--tilt-y', '0deg');
        if (cursorBlob) cursorBlob.classList.remove('is-near');
      });
    });
  }

  // Per-floater random parallax depth (subtle)
  floaters.forEach((el, i) => {
    el.dataset.depth = (((i * 37) % 100) / 100 * 0.6 + 0.15).toFixed(2); // 0.15–0.75
  });

  let raf = 0;
  let targetX = 0, targetY = 0;
  let curX = 0, curY = 0;

  function onMove(e) {
    const t = (e.touches && e.touches[0]) || e;
    const w = window.innerWidth, h = window.innerHeight;
    targetX = (t.clientX / w - 0.5) * 30;   // -15..+15 px
    targetY = (t.clientY / h - 0.5) * 20;   // -10..+10 px
    if (!raf) raf = requestAnimationFrame(tick);
  }

  function tick() {
    curX += (targetX - curX) * 0.08;
    curY += (targetY - curY) * 0.08;
    floaters.forEach((el) => {
      const d = parseFloat(el.dataset.depth);
      el.style.translate = `${(curX * d).toFixed(2)}px ${(curY * d).toFixed(2)}px`;
    });
    if (Math.abs(targetX - curX) > 0.05 || Math.abs(targetY - curY) > 0.05) {
      raf = requestAnimationFrame(tick);
    } else {
      raf = 0;
    }
  }

  window.addEventListener('mousemove', onMove, { passive: true });
  window.addEventListener('touchmove', onMove, { passive: true });

  // Reveal stagger on load
  floaters.forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform += ' translateY(8px)';
    setTimeout(() => {
      el.style.transition = 'opacity 0.6s ease, transform 0.6s cubic-bezier(.2,.8,.2,1)';
      el.style.opacity = '1';
      el.style.transform = el.style.transform.replace(' translateY(8px)', '');
    }, 80 + i * 60);
  });
})();
